import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    CreateBaseEstimateParameters,
    LinkOpportunityEstimateDto,
    OpportunityEstimateClient,
    OpportunityEstimateView,
    OpportunityEstimateViewPaginatedResultDto,
    SearchAvailableBaseEstimatesParameters,
    SearchBaseEstimateResultDto,
    SearchEstimateTemplatesParameters,
    SearchEstimateTemplatesResultDto,
    SearchOpportunityEstimateParameters,
    UnlinkOpportunityEstimateResultDto
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityEstimateService {
    constructor(private readonly client: OpportunityEstimateClient) {}

    async createBaseEstimate(body: CreateBaseEstimateParameters | undefined): Promise<OpportunityEstimateView> {
        return await lastValueFrom(this.client.opportunityEstimateCreateBaseEstimate(body));
    }

    async searchAvailableBaseEstimates(
        body: SearchAvailableBaseEstimatesParameters
    ): Promise<SearchBaseEstimateResultDto[]> {
        return await lastValueFrom(this.client.opportunityEstimateSearchAvailableBase(body));
    }

    async getEstimatesInfoByOpportunity(opportunityId: number): Promise<OpportunityEstimateView[]> {
        return await lastValueFrom(this.client.opportunityEstimateGetEstimatesInfoByOpportunity(opportunityId));
    }

    async searchAlternateEstimatesByOpportunity(
        body: SearchOpportunityEstimateParameters
    ): Promise<OpportunityEstimateViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityEstimateSearchAlternateEstimatesByOpportunity(body));
    }

    async searchBaseEstimateTemplates(
        body: SearchEstimateTemplatesParameters
    ): Promise<SearchEstimateTemplatesResultDto[]> {
        return await lastValueFrom(this.client.opportunityEstimateSearchBaseEstimateTemplates(body));
    }

    async linkBaseEstimate(body: LinkOpportunityEstimateDto): Promise<OpportunityEstimateView> {
        return await lastValueFrom(this.client.opportunityEstimateLink(body));
    }

    async unlinkBaseEstimate(opportunityId: number): Promise<UnlinkOpportunityEstimateResultDto> {
        return await lastValueFrom(this.client.opportunityEstimateUnlink(opportunityId));
    }

    async searchFinalEstimatesByOpportunity(
        body: SearchOpportunityEstimateParameters
    ): Promise<OpportunityEstimateViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityEstimateSearchFinalEstimatesByOpportunity(body));
    }
}
